import {
  NewTextInputFormComponent,
  NewTextInputFormComponentProps,
} from "./NewTextInputComponent";
import {
  NewPasswordInputComponent,
  PasswordInputComponentProps,
} from "./NewPasswordInputComponent";
import {
  NewQueryDropdownFieldComponent,
  NewQueryDropdownFieldComponentProps,
} from "./NewQueryDropdownFieldComponent";
import {
  NewHardcodedDropdownFormComponent,
  NewHardcodedDropdownFormComponentProps,
} from "./NewHardcodedDropdownFormComponent";
import {
  NewRadioButtonFieldComponent,
  NewRadioButtonFieldComponentProps,
} from "./NewRadioButtonFieldComponent";
import {
  NewMultipleSelectionQueryDropdownFieldComponent,
  NewMultipleSelectionQueryDropdownFieldComponentProps,
} from "./NewMultipleSelectionQueryDropdownFieldComponent";
import {
  NewIntTextInputFormComponent,
  NewIntTextInputFormComponentProps,
} from "./NewIntTextInputComponent";
import {
  NewCheckboxFormComponent,
  NewCheckboxFormComponentProps,
} from "./NewCheckboxFieldComponent";
import {
  MultipleTextFieldFormComponent,
  MultipleTextFieldFormComponentProps,
} from "./MultipleTextFieldFormComponent";

export const FormFieldComponent = (props: {
  props: FormFieldComponentProps;
  data: any;
  setData: any;
}) => {
  return (
    <>
      {props.props.type === "text" && (
        <NewTextInputFormComponent
          props={props.props}
          data={props.data}
          setData={props.setData}
        />
      )}
      {props.props.type === "password" && (
        <NewPasswordInputComponent
          props={props.props}
          data={props.data}
          setData={props.setData}
        />
      )}
      {props.props.type === "hardcoded" && <></>}
      {props.props.type === "query_dropdown" && (
        <NewQueryDropdownFieldComponent
          props={props.props}
          data={props.data}
          setData={props.setData}
        />
      )}
      {props.props.type === "hardcoded_dropdown" && (
        <NewHardcodedDropdownFormComponent
          props={props.props}
          data={props.data}
          setData={props.setData}
        />
      )}
      {props.props.type === "radio_button" && (
        <NewRadioButtonFieldComponent
          props={props.props}
          data={props.data}
          setData={props.setData}
        />
      )}
      {props.props.type === "multiple_selection_query_dropdown" && (
        <NewMultipleSelectionQueryDropdownFieldComponent
          props={props.props}
          data={props.data}
          setData={props.setData}
        />
      )}
      {props.props.type === "int_text" && (
        <NewIntTextInputFormComponent
          props={props.props}
          data={props.data}
          setData={props.setData}
        />
      )}
      {props.props.type === "checkbox" && (
        <NewCheckboxFormComponent
          props={props.props}
          data={props.data}
          setData={props.setData}
        />
      )}
      {props.props.type === "multiple_text_fields" && (
        <MultipleTextFieldFormComponent
          props={props.props}
          data={props.data}
          setData={props.setData}
        />
      )}
    </>
  );
};

export type FormFieldComponentProps =
  | NewTextInputFormComponentProps
  | PasswordInputComponentProps
  | {
      type: "hardcoded";
      key: string;
      value: any;
    }
  | NewMultipleSelectionQueryDropdownFieldComponentProps
  | NewQueryDropdownFieldComponentProps
  | NewHardcodedDropdownFormComponentProps
  | NewRadioButtonFieldComponentProps
  | NewIntTextInputFormComponentProps
  | NewCheckboxFormComponentProps
  | MultipleTextFieldFormComponentProps;
